import { BodySecondary, LabelStrong } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    expertise: string;
    id: number;
    imgSrc: string;
    name: string;
};

export const Curators = ({ expertise, id, imgSrc, name }: Props) => (
    <div
        className="mr-md mb-md flex"
        key={id}
    >
        <div className="relative flex h-[80px] w-[80px] min-w-[80px] items-center justify-center overflow-hidden rounded-full">
            <img
                alt={name}
                className="max-h-[80px] max-w-[80px] contain-content"
                height={80}
                src={imgSrc}
                width={80}
            />
        </div>
        <div className="ml-md flex w-full flex-col justify-center">
            <LabelStrong>{name}</LabelStrong>
            <BodySecondary color="secondary">{expertise}</BodySecondary>
        </div>
    </div>
);
